import dayjs from 'dayjs';

export const PAGE_SIZE = 6;
export const POSTS_PAGE_SIZE = PAGE_SIZE;

interface PlaceOfInterest {
  title: string;
  description: string;
  image: string;
}

interface FactFile {
  title: string;
  description: string;
}

interface Photo {
  title: string;
  image: string;
}

interface Destination {
  title: string;
  href: string;
  description: string;
  image: string;
  introduction: string;
  placesOfInterest: PlaceOfInterest[];
  factFile: FactFile[];
  photos: Photo[];
}

export const placesOfInterest: PlaceOfInterest[] = [
  {
    title: 'BAGHDAD',
    description:
      "Iraq's capital, the nation's capital and one of the great Arab cities of the world. At its peak, it was the centre of the Islamic world. Where the Abbasid dynasty built the fabled round city containing the Baytul-Hikmah (house of wisdom) and was the setting for many of tales from the Thousand and One Night tales. Some of this history still feels tangible in places such as the Mustansiriya Madrassah, the copper market and century-old tea shops. Baghdad plays host to two of Iraq's more 'modern' sites; the National Museum of Baghdad and the Al-Shaheed Monument. The Al-Shaheed Monument, otherwise known as the Martyr Monument, commemorates all those that have risked their life for Iraq particularly in dedication of the Iraqi soldiers that died in the Iran-Iraq War. The National Museum of Baghdad reopened its doors in 2015 after being looted in 2003 and successfully reclaiming approximately half of the stolen pieces, almost 100years after first being founded by British explorer Getrude Bell. Housing the history of humanity, the museum possesses countless artefacts dating back to the Sumerian, Babylonian and Assyrian empires in the cradle of civilisation.",
    image:
      'https://untamedborders.com/wp-content/uploads/2025/01/1-Al-Shaheed-Monument-Baghdad-scaled.jpg',
  },
  {
    title: 'NAJAF AND KARBALA',
    description:
      "The busy pilgrim towns of Najaf and Karbala in Southern Iraq are host to two of the holiest places in Shia Islam. Karbala is the city in which the Shia martyr, Imam Hussein, was killed during the battle of Kerbala. His death is commemorated every year by Shia Muslims on Ashura. Nearby is the Fortress of Al-Ukhaidir, famous for its unique rectangular defensive structure dating back to the 8th century. Further South is the other important Shia Islam pilgrimage site, Najaf. It is home to the shrine of the Imam Ali, found within the Najaf Mosque. The religious significance for Shia Muslims of being buried in Najaf has also led it to be home of the world's biggest cemetery Wadi-us-Salaam, also known as the Valley of Peace. Al Khifal is situated between these two sites, with its ancient covered souk.",
    image:
      'https://untamedborders.com/wp-content/uploads/2025/01/4-Karbala-scaled.jpg',
  },
  {
    title: 'BABYLON',
    description:
      "Babylon is one of the better-known cities of Mesopotamia, having forever been sought after as a prize for conquering empires. Famous for allegedly being the home of the Hanging Gardens of Babylon, and the definite site of the Lion of Babylon and the azure Ishtar Gate. Much of the city has been heavily reconstructed with many of the bricks being engraved with Saddam Hussein's name. Copying his ancient predecessors who adopted similar methods as a way to ensure they were written into the history of the city. It is also possible to visit Saddam Hussein's palace he had built overlooking the archaeological site.",
    image: 'https://untamedborders.com/wp-content/uploads/2025/01/153-scaled.jpg',
  },
];

const factFile: FactFile[] = [
  {
    title: 'VISAS',
    description:
      'Visa required for most nationalities. Must be applied for in advance at Chinese Embassy/ Consulate.',
  },
  {
    title: 'WEATHER',
    description:
      'Wide variety of temperatures and climates. Tropical, temperate, and plateau climates all present.',
  },
  {
    title: 'ELECTRICITY',
    description:
      'Three prong style system found in China and South Pacific (type I). Two prong USA style system (type A). European two prong style socket (type C).',
  },
  {
    title: 'WIFI',
    description:
      'Most guesthouses and hotels have adequate Wifi. In cities 4G works well. Not possible to use WhatsApp or Gmail.',
  },
  {
    title: 'FOOD',
    description:
      'Cuisine varies widely depending upon where you are in China. Rice is a staple largely in the south whilst wheat is a more common staple in the North. Dishes often feature meat. Spice levels vary.',
  },
  {
    title: 'ALCOHOL',
    description: 'Alcohol is permitted and is widely available',
  },
  {
    title: 'LANGUAGE',
    description:
      'Mandarin and Cantonese. Multiple other regional languages and dialects also spoken.',
  },
  {
    title: 'RELIGION',
    description:
      'Officially an atheist country. Buddhism, Christianity and Islam are all recognised by the state',
  },
  {
    title: 'DRESS CODE',
    description: 'No special dress code.',
  },
  {
    title: 'SAFTEY &amp; SECURITY',
    description: 'The FCO considers China to be a low risk region to travel.',
  },
];

const photos: Photo[] = [
  {
    title: 'Photo 1',
    image: 'https://picsum.photos/200/199',
  },
  {
    title: 'Photo 2',
    image: 'https://picsum.photos/200/200',
  },
  {
    title: 'Photo 3',
    image: 'https://picsum.photos/200/201',
  },
  {
    title: 'Photo 4',
    image: 'https://picsum.photos/200/202',
  },
  {
    title: 'Photo 5',
    image: 'https://picsum.photos/200/203',
  },
  {
    title: 'Photo 6',
    image: 'https://picsum.photos/200/204',
  },
  {
    title: 'Photo 7',
    image: 'https://picsum.photos/200/205',
  },
  {
    title: 'Photo 8',
    image: 'https://picsum.photos/200/206',
  },
  {
    title: 'Photo 9',
    image: 'https://picsum.photos/200/207',
  },
];

export const destinations: Destination[] = [
  {
    title: 'Iraq',
    href: '/destinations/iraq',
    description: 'Visit the first civilization in the history of mankind',
    image: '/images/destinations/iraq.webp',
    introduction:
      'Travel to Iraq, one of the cradles of civilisation. Situated between the Euphrates and the Tigris, ancient Mesopotamia pre-dates written history. Sumerian, Babylonian and Assyrian empires controlled the region, leaving behind a bounty of historical sites and artefacts. The diverse landscape, geographically and culturally, holds unforeseen adventures of lonely desert forts and spiralling minarets. A country better known for deserts also boasts marshlands in the South and the Zagros Mountains in the North, which play host to our ski trips each winter. The Arab Islamic conquest in the 7th century paved the way for the establishment of Islam, which continues to be an important part of the countries culture. Iraq is host to the two holy places of Shia Islam, Najaf and Karbala, as well as the spiritual home of the Yazidi people, Lalish. Beyond the awe-inspiring sites and landscapes, above all, the hospitality of the people across the country, from the Arabs in the South to the Kurds in the North, is often the most lasting memory.',
    placesOfInterest,
    factFile,
    photos,
  },
  {
    title: 'Jordan',
    href: '/destinations/jordan',
    description: 'Visit the most beautiful city in the world',
    image: '/images/destinations/jordan.webp',
    introduction:
      'Jordan is a country of contrasts, with a rich history and culture, and a diverse landscape. From the Dead Sea to the Wadi Rum desert, Jordan has something for everyone.',
    placesOfInterest,
    factFile,
    photos,
  },
  {
    title: 'Oman',
    href: '/destinations/oman',
    description: 'Visit the most beautiful city in the world',
    image: '/images/destinations/oman.webp',
    introduction:
      'Oman is a country of contrasts, with a rich history and culture, and a diverse landscape. From the Dead Sea to the Wadi Rum desert, Oman has something for everyone.',
    placesOfInterest,
    factFile,
    photos,
  },
];

export interface Trip {
  id: number;
  name: string;
  image: string;
  price: number;
  duration: string;
  maxPeople: number;
  destination: string;
  description: string;
}

export const trips: Trip[] = [
  {
    id: 1,
    name: 'Najaf',
    image: 'https://picsum.photos/600/400?nature=1',
    price: 1500,
    duration: '10-15 Days',
    maxPeople: 20,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
  {
    id: 2,
    name: 'Karbala',
    image: 'https://picsum.photos/600/400?nature=2',
    price: 2000,
    duration: '9-12 Days',
    maxPeople: 15,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
  {
    id: 3,
    name: 'Diwaniyah',
    image: 'https://picsum.photos/600/400?nature=3',
    price: 1800,
    duration: '9-12 Days',
    maxPeople: 20,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
  {
    id: 4,
    name: 'Hilla',
    image: 'https://picsum.photos/600/400?nature=4',
    price: 1600,
    duration: '4-8 Days',
    maxPeople: 25,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
  {
    id: 5,
    name: 'Baghdad',
    image: 'https://picsum.photos/600/400?nature=5',
    price: 1400,
    duration: '9-12 Days',
    maxPeople: 16,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
  {
    id: 6,
    name: 'Mousl',
    image: 'https://picsum.photos/600/400?nature=6',
    price: 2400,
    duration: '9-12 Days',
    maxPeople: 12,
    destination: 'Iraq',
    description: 'Visit the most beautiful city in the world',
  },
];

export const services = [
  {
    id: 1,
    title: 'Visa',
    href: '/services/visa',
    description: 'Get professional assistance with your visa application process',
    rating: 4.9,
    image: '/images/visa.jpeg',
    alt: 'Visa services for Iraq Jordan Oman and other middle eastern countries',

    pageTitle: 'Get Your Travel Visa—Easy, Fast & Stress-Free',
    pageDescription:
      "Tell us where you're headed, and we'll handle the rest. Submit your details below and we’ll take care of your visa application.",
  },
  {
    id: 2,
    title: 'Flight Ticket',
    href: '/services/flight',
    description: 'Book your flight tickets to destinations around the world',
    rating: 4.7,
    image: '/images/flights.jpeg',
    alt: 'Flight booking for Iraq , oman and Jordan international and domestic flights',
    pageTitle: 'Find the Best Flights for Your Trip',
    pageDescription:
      "Let us know where you're flying from and to. We’ll handle the search and send you the best options.",
  },
  {
    id: 3,
    title: 'Transportation',
    href: '/services/car',
    description: 'Rent a car for your journey with our convenient service',
    rating: 4.8,

    image: '/images/car-rentals.jpeg',
    alt: 'Car rental with or without a driver I Iraq and other Middle Eastern countries',
    pageTitle: 'Book a Car for Your Trip—Wherever You Go',
    pageDescription:
      'Fill out your travel details and choose your destination—we’ll match you with the best car rental options.',
  },
  {
    id: 4,
    title: 'Custom Trip',
    href: '/services/custom',
    description: 'Create your personalized trip with our custom planning service',
    rating: 4.9,

    image: '/images/custom-trips.jpeg',
    pageTitle: 'Custom made trips to Iraq and the Middle East',
    pageDescription:
      'Share your travel preferences and destination—we’ll design a tailor-made itinerary just for you.',
  },
];

export interface Post {
  id: string;
  title: string;
  type: 'Article' | 'News';
  createdAt: Date;
  coverId: string;
  coverUrl: string;
}

const title = [
  'Top 10 Hidden Gems in Iraq',
  'Best Time to Visit Jordan: A Seasonal Guide',
  'Cultural Etiquette When Traveling in the Middle East',
  'Must-Try Foods in Oman',
  'Photography Tips for Desert Landscapes',
  'The Best Places to Visit in Iraq',
  'The Best Places to Visit in Jordan',
  'The Best Places to Visit in Oman',
  'What to Pack for a Trip to the Middle East',
];

function generatePost(count: number) {
  const posts: Post[] = [];
  for (let i = 0; i < count; i++) {
    const randomTitle = title[Math.floor(Math.random() * title.length)] ?? '';
    const randomType = Math.random() < 0.5 ? 'Article' : 'News';
    const randomDate = dayjs()
      .subtract(Math.floor(Math.random() * 365), 'day')
      .toDate();
    posts.push({
      id: i.toString(),
      title: randomTitle,
      type: randomType,
      createdAt: randomDate,
      coverId: i.toString(),
      coverUrl: `https://picsum.photos/seed/${randomTitle}/800/500`,
    });
  }
  return posts;
}

export const featuredPosts: Post[] = generatePost(15);

// Helper functions for posts
export const getPostUrl = (id: string, type: string) => {
  const baseUrl = type === 'Article' ? '/posts/articles' : '/posts/news';
  return `${baseUrl}/${id}`;
};
